<script lang="ts">
  export let onClose: () => void;
</script>

<div class="cloud-close-button-wrapper">
  <img
    class="activity-cloud"
    alt="oblacek"
    src={`${__PUBLIC_PATH__}images/oblacek.svg`}
  />
  <button class="close-button" on:pointerup={onClose} />
</div>

<style>
  .cloud-close-button-wrapper {
    pointer-events: auto;
    position: relative;
    max-height: 100%;
    max-width: 100%;
  }

  .activity-cloud {
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: -1;
    filter: drop-shadow(-16px 0px 0px hsla(204, 30%, 67%, 1));
  }

  .close-button {
    all: unset;
    width: 5vmin;
    height: 5vmin;
    position: absolute;
    right: 13.5%;
    top: 8.5%;
    z-index: 100000000;
    cursor: pointer;
  }
</style>
